import {defineStore} from 'pinia'
import {useCustomerService} from '@/composables/customer_service.js'
import {useUserStore} from '@/store/user.js'
import {translationExpanded} from '~/plugins/translation_helper.js'
import * as Sentry from '@sentry/browser'

export const useCustomerSettingsStore = defineStore('CustomerSettingsModule', {
  state: () => ({
    settings: [],
    settingsValues: [],
    settingsAge: 0,
    settingsValuesAge: 0,
    settingsCustomer: 'none',
    useOwnArticleNo: false,
    damIntegrationSettings: null
  }),
  getters: {
    currentCustomerSettings() {
      return this.settings
    },
    currentCustomerSettingsValues() {
      return this.settingsValues
    },
    currentDamIntegrationSettings() {
      return this.damIntegrationSettings
    }
  },
  actions: {
    async fetchCustomerSettings(force = false) {
      const {getSettings} = useCustomerService()
      const CUSTOMER_SETTINGS_MAX_AGE = useRuntimeConfig().public.CUSTOMER_SETTINGS_MAX_AGE || 3600000
      const currentTime = new Date().getTime()
      const userStore = useUserStore()
      const currentCustomerUuid = userStore.loadedCustomerUuid
      if (force || (currentCustomerUuid !== 'default' &&
      (currentCustomerUuid !== this.settingsCustomer.value ||
        currentTime > this.settingsAge.value + CUSTOMER_SETTINGS_MAX_AGE))) {
        const res = await getSettings(currentCustomerUuid)
        if (res) {
          this.settings = res
          this.settingsAge = currentTime
          this.settingsCustomer = currentCustomerUuid
        }
      }
    },
    async fetchCustomerSettingsValues() {
      const {getSettingValues} = useCustomerService()
      const CUSTOMER_SETTINGS_MAX_AGE = useRuntimeConfig().public.CUSTOMER_SETTINGS_MAX_AGE || 3600000
      const currentTime = new Date().getTime()
      const userStore = useUserStore()
      const currentCustomerUuid = userStore.loadedCustomerUuid
      if (currentCustomerUuid !== 'default' &&
        (currentCustomerUuid !== this.settingsCustomer ||
          currentTime > this.settingsValuesAge + CUSTOMER_SETTINGS_MAX_AGE)) {
        const res = await getSettingValues(currentCustomerUuid)
        if (res) {
          this.settingsValues = res
          this.settingsValuesAge = currentTime
          this.settingsCustomer = currentCustomerUuid
        }
      }
    },
    async fetchDAMIntegrationSettings() {
      const app = useNuxtApp()
      const userStore = useUserStore()
      const {getDAMIntegrationSettings} = useCustomerService()
      const showDamError = () => {
        const {t, te} = app.$i18n
        app.$toast?.error(translationExpanded('headerManagement.DAMAccessUnavailable', 'management', undefined, {t, te}))
      }
      try {
        const damIntegrationSetting = await getDAMIntegrationSettings(userStore.currentAccessToken)
        this.damIntegrationSettings = damIntegrationSetting
        if (!damIntegrationSetting) {
          this.damIntegrationSettings = damIntegrationSetting
          showDamError()
          Sentry.captureMessage('Access to the DAM is not available', {
            level: 'warning'
          })
        }
      } catch {
        showDamError()
        Sentry.captureMessage('Access to the DAM is not available', {
          level: 'warning'
        })
      }
    },
    async updateSettings(updatedSettings) {
      let storeSettings = this.settings.filter(s => updatedSettings.some(us => us.settingUuid === s.customerSettingUuid)).map(setting => {
        let newSettingValue = updatedSettings.find(us => us.settingUuid === setting.customerSettingUuid).value
        return {customerSettingValue: newSettingValue, customerSettingUuid: setting.customerSettingUuid, customerSettingType: setting.customerSettingType}
      })
      for (let {customerSettingUuid, customerSettingValue} of storeSettings) {
        let setting = this.settings.find(s => s.customerSettingUuid === customerSettingUuid)
        if (setting) {
          setting.customerSettingValue = customerSettingValue
        }
      }
    }
  }
})
